import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Profil } from './pages/Profil';
import { Bimbingan } from './pages/Bimbingan';
import { BimbinganBooking } from './pages/BimbinganBooking';
import { Konseling } from './pages/Konseling';
import { Edukasi } from './pages/Edukasi';
import { OrangTua } from './pages/OrangTua';
import { Asesmen } from './pages/Asesmen';
import { Jurnal } from './pages/Jurnal';
import { Pelaporan } from './pages/Pelaporan';
import { RateUs } from './pages/RateUs';
import { LaporanAdmin } from './pages/LaporanAdmin';
export function App() {
  return <AuthProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          {/* PUBLIC */}
          <Route path="/login" element={<Login data-id="element-4" />} data-id="element-3" />
          <Route path="/register" element={<Register data-id="element-6" />} data-id="element-5" />

          {/* LAYOUT */}
          <Route element={<Layout data-id="element-8" />} data-id="element-7">
            <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />

            {/* PROTECTED */}
            <Route path="/profil" element={<ProtectedRoute data-id="element-12">
                  <Profil data-id="element-13" />
                </ProtectedRoute>} data-id="element-11" />

            <Route path="/bimbingan" element={<ProtectedRoute data-id="element-15">
                  <Bimbingan data-id="element-16" />
                </ProtectedRoute>} data-id="element-14" />

            <Route path="/bimbingan_booking" element={<ProtectedRoute data-id="element-18">
                  <BimbinganBooking data-id="element-19" />
                </ProtectedRoute>} data-id="element-17" />

            <Route path="/konseling" element={<ProtectedRoute data-id="element-21">
                  <Konseling data-id="element-22" />
                </ProtectedRoute>} data-id="element-20" />
            <Route path="/edukasi" element={<ProtectedRoute data-id="element-24">
                  <Edukasi data-id="element-25" />
                </ProtectedRoute>} data-id="element-23" />
            <Route path="/orang-tua" element={<ProtectedRoute data-id="element-27">
                  <OrangTua data-id="element-28" />
                </ProtectedRoute>} data-id="element-26" />
            <Route path="/asesmen" element={<ProtectedRoute data-id="element-30">
                  <Asesmen data-id="element-31" />
                </ProtectedRoute>} data-id="element-29" />
            <Route path="/jurnal" element={<ProtectedRoute data-id="element-33">
                  <Jurnal data-id="element-34" />
                </ProtectedRoute>} data-id="element-32" />
            <Route path="/pelaporan" element={<ProtectedRoute data-id="element-36">
                  <Pelaporan data-id="element-37" />
                </ProtectedRoute>} data-id="element-35" />
            <Route path="/rate-us" element={<ProtectedRoute data-id="element-39">
                  <RateUs data-id="element-40" />
                </ProtectedRoute>} data-id="element-38" />
            <Route path="/laporan-admin" element={<ProtectedRoute data-id="element-42">
                  <LaporanAdmin data-id="element-43" />
                </ProtectedRoute>} data-id="element-41" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}